import React from 'react';
import cx from 'clsx';
import { Badge } from '@kcd/design-system';

import { useLinkComponent } from '~/hooks/mobileApp';
import useAddCartTooltipStore from '~/store/global/useAddCartTooltipStore';
import { changedByFontScale } from '~/utils/fontScale';

import { useShoppingCartCount } from './queries';
import AddCartTooltip from '../coupons/components/AddCartTooltip';
import AddCartTooltipMypage from '../coupons/components/AddCartTooltipMypage';

import CartIcon from '~/assets/icons/gnb/ic_cart_line_24x24.svg';

function ShoppingCartLinkContent({ count }: { count: number }) {
  const LinkComponent = useLinkComponent();
  const { isVisible } = useAddCartTooltipStore();

  return (
    <LinkComponent href="/cart">
      <span className="relative block p-6 text-transparent">
        <CartIcon />
        {count > 0 && (
          <Badge
            className={cx([
              'absolute top-4 left-[18px]',
              changedByFontScale() && '-top-[0.75em] -right-[0.75em]',
            ])}
            type="number"
            text={count}
          />
        )}
        {isVisible &&
          (window.location.pathname === '/mypage' ? (
            <AddCartTooltipMypage />
          ) : (
            <AddCartTooltip />
          ))}
      </span>
    </LinkComponent>
  );
}

const ShoppingCartLinkContainer = () => {
  const { count } = useShoppingCartCount();

  return <ShoppingCartLinkContent count={count} />;
};

const ShoppingCartLink = () => {
  return (
    <React.Suspense fallback={<ShoppingCartLinkContent count={0} />}>
      <ShoppingCartLinkContainer />
    </React.Suspense>
  );
};

export default ShoppingCartLink;
